export default __webpack_public_path__ + "static/media/storeOpenClose.7bab4023.svg";